import Helper from "./Helper";

class TableChartPopup {
  constructor(config = {}) {
    // CONFIG
    const tableRowselector = ".ns-table-tab070 tr";
    this.accentClass = 'ns-backgroundcolor-tabellenhg';

    // USEFUL ELEMENTS
    this.body = document.querySelector('body');
    this.rows = Array.prototype.slice.call(document.querySelectorAll(tableRowselector));

    // INITS
    this.categories = [];

    // CHART CONFIG
    let language = document.querySelector("html").getAttribute("lang");
    this.lang = language.substring(0, 2);
    this.decimalPoint = "."; // default value
    this.numericSymbols = ["k", "M", "G", "T", "P", "E"]; // default value
    this.thousandsSep = " ";

    if (this.lang == "de") {
      // this.decimalPoint = ",";
      this.numericSymbols = ["Tsd.", "Mio."];
    }

    Highcharts.setOptions({
      lang: {
        decimalPoint: this.decimalPoint,
        numericSymbols: this.numericSymbols,
        thousandsSep: this.thousandsSep,
      },
    });

    // GET STARTED IF TABLE EXISTS
    if (this.rows.length > 0) {
      this.prepTable();
      this.prepPopup();
    }
  }

  prepTable() {
    const cats = [];
    this.rows.forEach((row, index) => {
      const cells = Array.prototype.slice.call(row.querySelectorAll("td"));
      const chartInfo = {};
      const data = [];
      let toggle = null;
      cells.forEach((cell, i) => {
        const cellText = cell.textContent.trim();
        if(cellText.length > 0){
          if (cellText != "highchart-toggle") {
            if (index == 0) {
              cats.push(cellText);
            } else {
              if (i == 0) {
                chartInfo.name = cellText;
              } else {
                const point = this.createDataPoint(cell);
                if(point){
                  data.push(point);
                }
                if(cellText.includes("/")){
                  chartInfo.needsSplit = true;
                }
                if (cellText.includes("%")) {
                  chartInfo.percent = true;
                }
              }
            }
          } else {
            toggle = cell;
          }
        }
      });
      chartInfo.data = data.reverse();
      if (toggle) {
        this.registerToggle(toggle, chartInfo);
      }
    });
    const categories = cats.filter(function (el) {
      return el != " ";
    });
    this.categories = categories.reverse();
  }

  prepPopup() {
    const content = document.querySelector(".content");
    this.popup = document.createElement("div");
    this.backdrop = document.createElement("div");
    Helper.addClass(this.popup, "ns-chart-popup");
    Helper.addClass(this.backdrop, "ns-chart-popup-backdrop");
    this.popup.innerHTML =  `<div class="ns-chart-popup__title"></div>
                            <div class="ns-chart-popup__chart-wrapper">
                              <div id="popup-chart-container"></div>
                            </div>`;

    content.append(this.popup);
    this.body.append(this.backdrop);
    this.backdrop.addEventListener('click', e => {
      Helper.removeClass(document.querySelector('.active-chart-toggle'), 'active-chart-toggle');
      Helper.removeClass(this.body, 'chart-popup-open');
      Helper.fadeOut(this.popup);
      this.emptyPopup()
    });
  }

  registerToggle(toggle, chartInfo) {
    Helper.removeClass(toggle, "ns-vertical-top");
    Helper.removeClass(toggle, "ns-horizontal-left");
    Helper.addClass(toggle, "ns-vertical-bottom");
    Helper.addClass(toggle, "ns-horizontal-right");
    toggle.querySelector("p").innerHTML = '<div class="ns-table-chart-toggle"><span class="sr">toggle chart</span></div>';
    toggle.addEventListener("click", (e) => {
      if(!Helper.hasClass(toggle, 'active-chart-toggle')){
        [...document.querySelectorAll('.ns-table-chart-toggle')].forEach(toggler => {
          Helper.removeClass(toggler, 'active-chart-toggle');
        });
        this.emptyPopup();
        this.positionPopup(toggle);
        this.buildChart(toggle, chartInfo);
      } else {
        Helper.removeClass(toggle, 'active-chart-toggle');
        Helper.removeClass(this.body, 'chart-popup-open');
        Helper.fadeOut(this.popup);
        this.emptyPopup()
      }
    });
  }


  createDataPoint(cell) {
    const cellText = cell.innerText;
    if(cellText == " "){
      return;
    } else {
      const point = {};
      let cleanNumString = cellText.replace(this.decimalPoint, ".").replace(this.thousandsSep, "");
      if (cleanNumString.includes("(")) {
        cleanNumString = cleanNumString.replace("(", "-").replace(")", "");
      }
      let number;
      if(cleanNumString.includes('/')){
        number = cleanNumString;
      } else {
        number = parseFloat(cleanNumString);
      }
      point.y = number;
      if(Helper.hasClass(cell, this.accentClass)){
        point.colorIndex = 0;
      }
      return point;
    }
  }

  positionPopup(toggle){
    Helper.fadeIn(this.popup);
    Helper.addClass(this.body, 'chart-popup-open');
    Helper.addClass(toggle, 'active-chart-toggle');
    const row = toggle.parentElement;
    const toggleOffset = Helper.offset(row);
    const topOffset = toggleOffset.top;
    const headerHeight = document.querySelector('.header').offsetHeight;
    const rowHeight = row.offsetHeight;
    this.popup.style.top = (topOffset - headerHeight + rowHeight)+'px';
  }

  buildChart(toggle, chartInfo) {
    const chartContainer = this.popup.querySelector(".ns-chart-popup__chart-wrapper");
    const chartTitleContainer = this.popup.querySelector(".ns-chart-popup__title");
    const containerID = "popup-chart-container";
    chartTitleContainer.innerHTML = chartInfo.name;
    const cats = this.categories;
    chartInfo.colorIndex = 2; // overwriting color
    let labelFormat = '{point.y:,.2f}';
    if(chartInfo.percent){
      labelFormat = '{point.y:,.2f}%';
    }

    let seriesArr = [];

    if(chartInfo.needsSplit){
      seriesArr = this.makeTwoSeries(chartInfo);
    } else {
      seriesArr.push(chartInfo);
    }

    const containerElement = document.querySelector("#" + containerID);
    const chartOptions = {
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      chart: {
        styledMode: true,
        height: "47%",
        type: "column",
      },
      tooltip: {
        enabled: false,
      },
      yAxis: [
        {
          allowDecimals: true,
          startOnTick: true,
          endOnTick: true,
          tickWidth: 1,
          tickLength: 7,
          title: {
            text: "",
          },
        },
      ],
      plotOptions: {
        series:{
          pointWidth: 40,
          dataLabels: {
            enabled: true,
            crop: false,
            overflow: 'allow',
            allowOverlap: true,
            padding: 5,
            shape: 'callout',
            format: labelFormat,
            y: -10,
          }
        }
      },
      xAxis: {
        allowDecimals: true,
        startOnTick: true,
        endOnTick: true,
        categories: cats,
        tickWidth: 1,
        tickLength: 20,
      },
      series: seriesArr,
    };
    let chart = Highcharts.chart(containerID, chartOptions);
  }

  makeTwoSeries(chartInfo) {
    const seriesArr = [];
    const series1 = {};
    const series2 = {};
    series1.name = chartInfo.name;
    series2.name = chartInfo.name;
    series1.colorIndex = 2;
    series2.colorIndex = 3;
    series1.data = [];
    series2.data = [];
    chartInfo.data.forEach(point => {
      const point1 = {};
      const point2 = {};
      if(point.hasOwnProperty('colorIndex')){
        point1.colorIndex = point.colorIndex;
        point2.colorIndex = 1;
      }
      const numArray = point.y.split('/');
      point1.y = parseFloat(numArray[0]);
      point2.y = parseFloat(numArray[1]);
      series1.data.push(point1);
      series2.data.push(point2);
    });
    seriesArr.push(series1);
    seriesArr.push(series2);
    return seriesArr;
  }

  emptyPopup() {
    const chartTitleContainer = this.popup.querySelector(
      ".ns-chart-popup__title"
    );
    const chartID = "popup-chart-container";
    chartTitleContainer.innerHTML = "";
    document.querySelector("#" + chartID).innerHTML = "";
  }
}

export default TableChartPopup;
